import { useId, type ReactNode } from "react";
import { formatReadTime } from "../lib/readTime";
import { useNetwork } from "../lib/network";

/**
 * Every page's head: the title, when the page last read its data, the Network
 * dropdown (none on pages that cover every network), and an optional lead line.
 * The dropdown is the only network selector, so its choice holds on every page.
 */
export function PageHead({
  title,
  readAt,
  readText,
  network = true,
  lead,
}: {
  title: string;
  /** When the page last got an answer (`useReadTime`), or null before the first. */
  readAt: number | null;
  /** Replaces the read time's words ("Last read on BSC …" while the network is down). */
  readText?: string | undefined;
  network?: boolean;
  lead?: ReactNode | undefined;
}) {
  const { chains, chain, select } = useNetwork();
  const id = useId();
  return (
    <div className="console-page-head">
      <div className="console-page-headline">
        <h1 className="console-page-title">{title}</h1>
        <span className="console-page-read">{readText ?? formatReadTime(readAt)}</span>
      </div>
      {network && (
        <div className="console-page-network">
          <label htmlFor={id}>Network</label>
          <select id={id} className="mk-select console-page-network-select" value={chain.key} onChange={(e) => select(e.target.value)}>
            {chains.map((c) => (
              <option key={c.key} value={c.key}>
                {c.label}
              </option>
            ))}
          </select>
        </div>
      )}
      {lead !== undefined && <p className="console-page-sub">{lead}</p>}
    </div>
  );
}
